import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import LineItem from "./LineItem.js";
import HeadingFlexRow from "./HeadingFlexRow.js";
import ActionLinksRow from "./ActionLinksRow.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlexCard = _ref => {
  let {
    item,
    themeGroup,
    children
  } = _ref;
  const {
    lines,
    heading,
    toolTip,
    legendLabel,
    legendColor,
    footerLinks
  } = item || {};
  const theme = useTheme();
  const tg = themeGroup || theme;
  const renderLines = () => {
    // eslint-disable-next-line react/prop-types
    if (!lines || !lines.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children:
      // eslint-disable-next-line react/prop-types
      lines.map((line, index) => {
        const {
          label,
          value,
          units
        } = line;
        if (!label) {
          return null;
        }
        const safeValue = value || 0;
        return /*#__PURE__*/_jsx(LineItem, {
          variant: "inspector",
          sx: tg.cardContent,
          label: label,
          value: safeValue,
          units: units
        }, index);
      })
    });
  };
  return /*#__PURE__*/_jsxs(Box, {
    sx: tg === null || tg === void 0 ? void 0 : tg.flexCard,
    children: [/*#__PURE__*/_jsx(HeadingFlexRow, {
      heading: heading,
      toolTip: toolTip,
      legendColor: legendColor,
      legendLabel: legendLabel
    }), renderLines(), /*#__PURE__*/_jsx(ActionLinksRow, {
      links: footerLinks,
      themeGroup: tg
    }), children]
  });
};
FlexCard.propTypes = {
  item: PropTypes.objectOf(PropTypes.shape({
    heading: PropTypes.string,
    toolTip: PropTypes.string,
    legendLabel: PropTypes.string,
    legendColor: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
      link: PropTypes.string
    })),
    footerLinks: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string
    }))
  })),
  themeGroup: PropTypes.object,
  children: PropTypes.node
};
export default FlexCard;